"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SvgButton = _interopRequireDefault(require("./SvgButton"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 22px;\n  right: 22px;\n  width: 9px;\n  height: 9px;\n  color: #5e5e5e;\n  &:hover {\n    color: #000;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function Close(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick;
  return _react.default.createElement(_SvgButton.default, {
    className: className,
    onClick: onClick
  }, _react.default.createElement("svg", {
    viewBox: "0 0 9.1 9.1"
  }, _react.default.createElement("path", {
    fill: "currentColor",
    d: "M5.9 4.5l2.8-2.8c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L4.5 3.1 1.7.3C1.3-.1.7-.1.3.3c-.4.4-.4 1 0 1.4l2.8 2.8L.3 7.4c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3L4.5 6l2.8 2.8c.3.2.5.3.8.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L5.9 4.5z"
  })));
}

Close.propTypes = {
  className: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired
};
var StyledClose = (0, _styledComponents.default)(Close)(_templateObject());
var _default = StyledClose;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/reactour/dist/components/Close.js
// module id = 1887
// module chunks = 0